import { createContext, useContext, useState } from "react";

export const VisualFormContext = createContext();

export const VisualFormContextProvider = ({ children }) => {
    const [visualObject, setVisualObject] = useState();

    const closeVisualCreationDialog = () => {
        setVisualObject()
    };

    const openVisualCreation = (coordinateItem) => {
        setVisualObject({
            PositionX: coordinateItem.x,
            PositionY: coordinateItem.y,
            Width: coordinateItem.w,
            Height: coordinateItem.h
        });
    }

    const openVisualEdit = (visual) => {
        setVisualObject(visual);
    }

    return (
        <VisualFormContext.Provider
            value={{
                visualObject,
                openVisualCreation,
                openVisualEdit,
                setVisualObject,
                closeVisualCreationDialog,
            }}
        >
            {children}
        </VisualFormContext.Provider>
    );
}

export const useVisualFormContext = () => useContext(VisualFormContext);